import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowRight, X, Phone, Sparkles } from './Icons.jsx';
import { tutors } from '../lib/tutors.js';

const SESSION_KEY = 'mm-floating-tutor-dismissed';

export default function FloatingTutor() {
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(SESSION_KEY) === '1');
  const [show, setShow] = useState(false);
  const loc = useLocation();

  const hidden = loc.pathname.startsWith('/drill') || loc.pathname.startsWith('/tutor-portal') || loc.pathname === '/parents' || loc.pathname === '/medi';

  useEffect(() => {
    if (hidden || dismissed) { setShow(false); return; }
    const t = setTimeout(() => setShow(true), 6000);
    return () => clearTimeout(t);
  }, [hidden, dismissed, loc.pathname]);

  if (!show || hidden) return null;

  const dismiss = () => { sessionStorage.setItem(SESSION_KEY, '1'); setDismissed(true); setShow(false); };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} style={pillBtn} aria-label="Talk to a tutor">
        <img src={tutors[0].image} alt="" style={{ width: 28, height: 28, borderRadius: '50%' }} />
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2, textAlign: 'left' }}>
          <span style={{ fontSize: 11, opacity: 0.85, fontWeight: 600 }}>Talk to a tutor</span>
          <strong style={{ fontSize: 13 }}>Free 15-min chat</strong>
        </div>
        <ArrowRight width="16" height="16" />
      </button>
    );
  }

  return (
    <div style={panel}>
      <div style={panelHead}>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--brand-purple)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Medic Mind tutors</div>
          <strong style={{ fontSize: 16 }}>Free 15-min chat · no pitch</strong>
        </div>
        <button onClick={() => setOpen(false)} aria-label="Close" style={iconBtn}><X width="14" height="14" /></button>
      </div>
      <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {tutors.slice(0, 3).map((t) => (
          <a key={t.id} href="https://www.medicmind.co.uk/contact-us/" target="_blank" rel="noreferrer" style={{ ...tutorRow, textDecoration: 'none', color: 'inherit' }}>
            <img src={t.image} alt={t.name} style={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0 }} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
                <strong style={{ fontSize: 13.5 }}>{t.name}</strong>
                <span style={{ fontSize: 10.5, fontWeight: 700, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{t.score}</span>
              </div>
              <p style={{ margin: 0, fontSize: 11.5, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.specialty} · {t.nextSlot}</p>
            </div>
            <ArrowRight width="14" height="14" />
          </a>
        ))}
      </div>
      <button onClick={dismiss} style={dismissBtn}>
        <Sparkles width="12" height="12" />Hide for this visit
      </button>
    </div>
  );
}

const pillBtn = {
  position: 'fixed', bottom: 18, right: 18, zIndex: 60,
  display: 'flex', alignItems: 'center', gap: 10,
  padding: '8px 14px 8px 8px',
  background: 'linear-gradient(135deg, var(--brand-deep), var(--brand-purple))',
  color: '#fff', border: 'none', borderRadius: 999,
  cursor: 'pointer', fontFamily: 'inherit',
  boxShadow: '0 12px 28px rgba(35, 20, 63, 0.4)',
  animation: 'mm-slide-up 320ms ease'
};
const panel = {
  position: 'fixed', bottom: 18, right: 18, zIndex: 60,
  width: 'min(340px, calc(100vw - 36px))',
  background: '#fff', borderRadius: 16,
  boxShadow: '0 20px 50px rgba(35, 20, 63, 0.35)',
  border: '1px solid var(--border)',
  animation: 'mm-slide-up 320ms ease',
  overflow: 'hidden'
};
const panelHead = {
  padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
  borderBottom: '1px solid var(--border)'
};
const iconBtn = { background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 4 };
const tutorRow = {
  display: 'flex', alignItems: 'center', gap: 10,
  padding: 8, background: 'var(--card-soft)', border: '1px solid transparent',
  borderRadius: 10, cursor: 'pointer', textAlign: 'left',
  fontFamily: 'inherit', transition: 'border-color 150ms ease'
};
const dismissBtn = {
  width: '100%', padding: '10px', background: 'transparent', border: 'none',
  borderTop: '1px solid var(--border)',
  cursor: 'pointer', fontSize: 12, color: 'var(--text-muted)', fontWeight: 600,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6
};
